import { Helmet } from '@dr.pogodin/react-helmet';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import Loading from '../common/lib/Loading';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import CreditsUtils, { type CreditsIndexData } from './lib/CreditsUtils';

interface Props {
    lang: MultiLang;
}

const CreditsIndex = (props: Props) => {
    const { lang } = props;
    const [index, setIndex] = useState<CreditsIndexData | null | undefined>(undefined);

    useEffect(() => {
        let active = true;
        CreditsUtils.getIndex().then((index) => {
            if (active) {
                setIndex(index);
            }
        });
        return () => {
            active = false;
        };
    }, []);

    if (typeof index === 'undefined') {
        return <Loading />;
    }
    if (index === null) {
        return <PageNotFound lang={lang} />;
    }
    const mtitle = Functions.mlang(index.name, lang);
    return (
        <>
            <Helmet>
                <title>
                    {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{mtitle}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <ul>
                {index.pages.map((page) => (
                    <li key={page.id}>
                        <Link to={CreditsUtils.getPageUrl(page.id)}>{Functions.mlang(page.title, lang)}</Link>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default CreditsIndex;
